import React from 'react';
import './HomeSearch.css';

import { useCarFilter } from '../../../utils';
import { CarsSearch } from '../../../components';



const HomeSearch = () => {

  // Use the useCarFilter hook to manage filtering and pagination
  const { handleFormSubmit } = useCarFilter();

  return (

    <div className='home-search'>

      {/* Render the CarSearch component and pass the handleFormSubmit function */}
      <CarsSearch onFormSubmit={handleFormSubmit} />

    </div>

  );
};

export default HomeSearch;